import {
  oteApi
} from 'yxt-biz-pc/packages/api';

/**
 * 练习开始
 * @param {string} praId 练习ID
 */
export const getPraStart = (praId, usedTime = 0, trackId) => {
  return oteApi.get(`/upm/start?praId=${praId}&usedTime=${usedTime}&trackId=${trackId}`);
};

/**
 * 错题练习开始
 * @param {string} praId 练习ID
 */
export const getErrorPraStart = (praId, usedTime = 0, trackId) => {
  return oteApi.get(`/upm/wrong/start?praId=${praId}&usedTime=${usedTime}&trackId=${trackId}`);
};

/**
 * 练习单题提交
 * @param {string} praId 练习ID
 * @param {string} puId 练习用户ID
 * @param {object} bodyObj 请求体
 */
export const submitSingleAnswerOfpra = (praId, puId, bodyObj, trackId) => {
  return oteApi.put(`/upm/${praId}/users/${puId}/answer?trackId=${trackId}`, bodyObj);
};

/**
 * 练习单题提交
 * @param {string} praId 练习ID
 * @param {string} pumId 用户练习ID
 * @param {object} bodyObj 请求体
 */
export const submitSingleErrorAnswerOfpra = (praId, pumId, bodyObj, trackId) => {
  return oteApi.put(`/upm/${praId}/users/${pumId}/wrong/answer?trackId=${trackId}`, bodyObj);
};

/**
 * 练习退出
 * @param {string} praId 练习ID
 * @param {string} puId 练习用户ID
 * @param {object} bodyObj 请求体
 */
export const submitPractice = (praId, puId, uniqueId, usedTime = 0, trackId) => {
  return oteApi.put(`/upm/${praId}/users/${puId}/submit?uniqueId=${uniqueId}&usedTime=${usedTime}&trackId=${trackId}`);
};

/**
 * 练习退出(中途退出)
 * @param {string} praId 练习ID
 * @param {string} puId 练习用户ID
 * @param {object} bodyObj 请求体
 */
export const submitPracticeHalfway = (praId, puId, uniqueId, usedTime = 0, trackId) => {
  return oteApi.put(`/upm/${praId}/halfway/submit?uniqueId=${uniqueId}&usedTime=${usedTime}${puId ? ('&puId=' + puId) : ''}&trackId=${trackId}`);
};

/** 推送练习时长
* @param {object} data
* @returns
*/
export const postPracticeTime = (data, trackId) => {
  return oteApi.put(`/upm/practice/time?trackId=${trackId}`, data);
};

/** 删除用户最新作答中数据(修复试题删除bug)
* @param {string} praId 练习ID
* @returns
*/
export const deleteUserPracticeInfo = (praId) => {
  return oteApi.post(`/upm/deleteLastUserPra/${praId}`);
};

/**
 * @desc 获取机构水印配置
 * */

export const getOrgWatermarkConfig = () => {
  return oteApi.get('/watermark').then(res => ({
    opacity: res.otherAlpha * 1,
    fontSize: res.otherFontSize,
    color: '#' + res.otherColor,
    text: res.watermarkContent,
    ...res
  }));
};
